<template>
  <v-container>
    <br>
    <v-layout>
      <v-flex  class="text-xs-left pb-3">
        <h1>Lab openings</h1>
      </v-flex>
    </v-layout>

    <v-layout row wrap>

      <v-flex v-for="position in positions" :key="position.id" xs12>
        <v-card dark class="yellow darken-4">
        <v-container fluid>
        <v-layout>
        <v-flex xs3 class="yellow darken-4">
          <v-img
            :src="require(position.imgURL)"
            class="my-3"
            contain
            height="100"
          ></v-img>
        </v-flex>
          <v-flex xs3 class="yellow darken-4">
          <v-text align-left>
            <br>
            <h3>{{ position.name }} - {{ position.position }}</h3>
          </v-text>
        </v-flex>
        <v-flex xs3 class="yellow darken-4">
        <v-text align-left>
          <br>
          <h3>{{ position.description }}</h3>
        </v-text>
      </v-flex>
          <v-flex xs3 class="yellow darken-4" offset-xs2>
            <br><br>
          <v-btn large
          router to="/Position">
           Go >>
         </v-btn>
        </v-flex>
        </v-layout>
        </v-container>
        </v-card>
      </v-flex>



    </v-layout>
  </v-container>
</template>

<script>
export default {
data () {
  return {
    }
  },
  computed: {
    positions(){
      return this.$store.getters.loadedPositions
    }
  },
  mounted(){
    this.$store.dispatch('loadPositions')
  }
}
</script>
